// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import config from 'myWorld/base/config';
import pageHtml from 'text!html/phone/phone.html';
import 'myWorld/layouts/phone/phoneLayoutDetails';

myw.PhoneLayoutResultsListPage = myw.PhoneLayoutDetails.extend({
    attributes: {
        id: 'page-results-list'
    },

    /*
     * @class View to display all the features in a feature set
     * @param  {PhoneLayout}  owner   The owner of self.
     * @extends {PhoneLayoutDetails}
     * @constructs
     */
    initialize(owner) {
        const options = { prevPageName: 'page-map' };

        myw.PhoneLayoutDetails.prototype.initialize.call(this, owner, options);
        this.owner = owner;
        this.app = owner.app;

        this.$('.phone-layout-details-container').append(
            $('<div>', { id: 'results-content-table' })
        );
    },

    /*
     * Populates the title with the number of results being displayed
     */
    populateTitle() {
        let resultsMsg;

        const currentQueryDetails = this.app.getCurrentQueryDetails(),
            queryTotal = currentQueryDetails
                ? currentQueryDetails.totalCount
                : this.app.currentFeatureSet.totalCount,
            featuresSize = this.app.currentFeatureSet.size();

        // Set the feature brief to display the number of results returned
        if (featuresSize === config['core.queryResultLimit'] && featuresSize < queryTotal) {
            resultsMsg = this.owner.msg('first_num_results', { limit: featuresSize });
        } else if (this.app.currentFeatureSet.size()) {
            resultsMsg = this.owner.msg('num_results', {
                count: this.app.currentFeatureSet.size()
            });
        }
        this._update(resultsMsg);
    },

    /*
     * Gets the data to display on the page from myw.ResultsListControl
     */
    _update(numResults) {
        if (!this.owner.resultListControl)
            this.owner.resultListControl = new myw.ResultsListControl(this.owner, {
                el: this.$('.phone-layout-details-container')
            });
        this.$('.feature-title').html(numResults);
        this.owner.resultListControl.render();
    }
});

export default myw.PhoneLayoutResultsListPage;
